import styled from 'styled-components'
import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import chrome from '../../images/icons/chrome-icon.svg'
import firefox from '../../images/icons/firefox-icon.svg'
import edge from '../../images/icons/edge-icon.svg'
import heroImg from '../../images/hero-img.jpg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Grid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 50px;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
`
const Wrapper = styled.div`
  display: flex;
`
const Button = styled.a`
  padding: 10px 15px;
  border-radius: 5px;
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  width: fit-content;
  transition: 0.2s ease-in;

  &:hover {
    transition: 0.2s ease-in;
    opacity: 0.6;
  }

  &.btn-chrome {
    background: #09512e;
  }

  &.btn-firefox {
    background: #a85c14;
    margin: 0 10px;
  }

  &.btn-edge {
    background: #186da1;
  }
`
const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`
const Image = styled.img`
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
  width: 100%;
`

export default function Hero() {
  return (
    <Container>
      <div className="container">
        <Grid2 className="hero__grid2">
          <Grid1>
            <Title title="Dark mode for your writing." />
            <Description description="GDark is a free browser extension that provides dark mode for your online writing. Ease your eyes while working in documents, the dashboard, and more!" />
            <Wrapper className="hero__wrapper">
              <Button
                href="https://chrome.google.com/webstore/detail/grammarly-dark/noojmhngiheennhgaffkfboanjpbkpep?hl=en"
                className="btn-chrome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={chrome} alt="Chrome icon" />
                Download
              </Button>
              <Button
                href="https://addons.mozilla.org/en-US/firefox/addon/grammarly-dark/"
                className="btn-firefox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={firefox} alt="Firefox icon" />
                Download
              </Button>
              <Button
                href="https://microsoftedge.microsoft.com/addons/detail/grammarly-dark/kljjdbdffnbengiilkaiblpinbhfcfnc?hl=en-US%3Fhl%3Den-US"
                className="btn-edge"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={edge} alt="Edge icon" />
                Download
              </Button>
            </Wrapper>
          </Grid1>
          <Image src={heroImg} alt="GDark Extension Preview" />
        </Grid2>
      </div>
    </Container>
  )
}
